import { notifications } from "../Helpers/Notifications";

export default class ErrorHandler {
  processEtherMessage(exception) {
    console.log(exception);
    switch (exception.code) {
      case -32603:
      case -32002:
      case 4001:
        notifications.error(exception.message);

      case -32603:
        notifications.error(exception.data?.message);

      default:
        notifications.error(exception.reason);
    }
  }
}
